export const FAQ = [
  { q: "Wie lange dauert die Lieferung?", a: "Einzelbilder und kleine Aufträge liefere ich in der Regel innerhalb von 2–3 Werktagen. Bei Paketen (50–200 Bilder) stimmen wir einen Zeitplan ab – meist erhalten Sie erste Motive innerhalb weniger Tage und den Gesamtumfang gestaffelt. Eilaufträge sind nach Absprache möglich." },
  { q: "Welche Nutzungsrechte erhalte ich an den Bildern?", a: "Mit vollständiger Bezahlung erhalten Sie ein zeitlich und räumlich unbeschränktes Nutzungsrecht für alle vereinbarten Zwecke – Onlineshops, Marktplätze wie Amazon und eBay, Social Media, Werbeanzeigen und Print. Sie zahlen keine laufenden Lizenzgebühren." },
  { q: "Sind Korrekturschleifen enthalten?", a: "Ja. Pro Bild ist eine Korrekturschleife im Preis enthalten, in der wir Details wie Perspektive, Umgebung, Lichtstimmung oder Textelemente anpassen. Weitergehende Änderungswünsche setze ich nach Aufwand um – transparent und vorab abgestimmt." },
  { q: "Entsprechen die Bilder den Amazon-Bildrichtlinien?", a: "Ja. Hauptbilder erstelle ich auf reinweißem Hintergrund (RGB 255/255/255), mit dem Produkt als klarem Bildmittelpunkt, ohne Text, Logos oder Wasserzeichen und in hoher Auflösung, damit die Zoom-Funktion aktiv ist. Galeriebilder, Infografiken und A+ Content gestalte ich passend zu den jeweiligen Modulvorgaben." },
  { q: "Welche Unterlagen benötigen Sie von mir?", a: "Ideal sind vorhandene Produktfotos aus mehreren Perspektiven, Maße und Materialangaben, Ihr Logo und – falls vorhanden – Markenrichtlinien. Je klarer das Briefing, desto präziser das Ergebnis. Fehlt etwas, kläre ich es direkt im Erstgespräch." },
  { q: "Wie läuft die Zusammenarbeit ab?", a: "Anfrage über das Formular, kurzes Briefing, individuelles Angebot. Nach Ihrer Freigabe erstelle ich die Motive, Sie prüfen sie, eine Korrekturschleife folgt, anschließend erhalten Sie alle Dateien digital in den benötigten Formaten." },
  { q: "In welchen Formaten und Auflösungen erhalte ich die Dateien?", a: "Standardmäßig als JPG in hoher Auflösung (mindestens 2000 px, für Amazon empfohlen 3000 × 3000 px). Freisteller liefere ich zusätzlich als PNG mit transparentem Hintergrund. Weitere Formate oder Seitenverhältnisse für Instagram, Storys oder Ads sind auf Wunsch inklusive." },
  { q: "Wie erfolgt die Abrechnung?", a: "Sie erhalten eine Rechnung, zahlbar innerhalb von 14 Tagen. Als Kleinunternehmer gemäß § 19 UStG weise ich keine Umsatzsteuer aus – die angegebenen Preise sind Endpreise. Die Unlimited-Lösung wird monatlich im Voraus abgerechnet und ist monatlich kündbar." },
];


export const TESTIMONIALS = [
  { name: "Daniel K.", initials: "DK", role: "Amazon-Händler, Garten & Wellness", platform: "Amazon", stars: 5, quote: "Unsere Fasssauna wurde vorher mit einem einfachen Katalogbild verkauft. Mit den Ambiente-Bildern von Salgin Solutions ist die Klickrate deutlich gestiegen – und die Rückfragen zu Maßen sind dank der technischen Grafik fast verschwunden." },
  { name: "Sabine R.", initials: "SR", role: "Inhaberin, Möbel-Onlineshop", platform: "Shopify", stars: 5, quote: "Endlich Bilder, die nach Marke aussehen und nicht nach Freisteller. Schnelle Umsetzung, ein Ansprechpartner, faire Preise." },
  { name: "Murat T.", initials: "MT", role: "E-Commerce Manager, Fashion-Label", platform: "Instagram", stars: 5, quote: "Für unsere Kampagne brauchten wir innerhalb einer Woche 40 Motive. Die Lifestyle-Bilder wirken hochwertig und einheitlich – perfekt für Feed und Storys." },
  { name: "Christina W.", initials: "CW", role: "Geschäftsführerin, Elektro-Zubehör", platform: "eBay", stars: 5, quote: "Die Infografiken erklären unsere Produkte besser als jeder Text. Professionell, präzise und ohne großes Hin und Her." },
  { name: "Jonas B.", initials: "JB", role: "Gründer, Outdoor-Marke", platform: "WooCommerce", stars: 5, quote: "Das Pro-Paket hat sich für uns sofort gerechnet. Ein kompletter Produktkatalog in wenigen Tagen – Qualität wie ein echtes Fotoshooting." },
];


export const CONTACT = {
  company: "Salgin Solutions",
  owner: "Mustafa Salgin",
  street: "Hebbelweg 2",
  city: "32547 Bad Oeynhausen",
  email: "salshopde@gmail.com",
  phone: "0176 84773041",
  phoneHref: "tel:+4917684773041",
  whatsapp: "https://wa.me/4917684773041?text=" + encodeURIComponent("Hallo Salgin Solutions, ich interessiere mich für KI-Produktbilder und hätte gern ein Angebot."),
  taxNote: "Kleinunternehmer gemäß § 19 UStG",
};

export const NAV = [
  { id: "leistungen", label: "Leistungen" },
  { id: "portfolio", label: "Portfolio" },
  { id: "vergleich", label: "Vorher/Nachher" },
  { id: "kundenstimmen", label: "Kundenstimmen" },
  { id: "preise", label: "Preise" },
  { id: "faq", label: "FAQ" },
  { id: "blog", label: "Blog", to: "/blog" },
  { id: "kontakt", label: "Kontakt" },
];

export const PLATFORMS = [
  "Amazon", "eBay", "Shopify", "WooCommerce", "Eigene Onlineshops", "Instagram",
  "Facebook", "TikTok", "Pinterest", "Produktkataloge", "Werbeanzeigen",
];

export const PROBLEMS = [
  "Einfache Herstellerbilder",
  "Keine Emotionen",
  "Keine Erklärung des Produkts",
  "Geringe Aufmerksamkeit",
  "Niedrige Klickrate",
];

export const SERVICES = [
  { n: "01", title: "Amazon Listing Bilder", text: "Hauptbild, Galerie und Detailansichten – optimiert auf Klickrate und Conversion im Marketplace." },
  { n: "02", title: "Ambiente- & Lifestylebilder", text: "Ihr Produkt in realistischen Szenen, die Emotionen wecken und den Nutzen sofort verständlich machen." },
  { n: "03", title: "Technische Grafiken", text: "Maße, Materialien, Lieferumfang und Montage – präzise visualisiert für weniger Rückfragen." },
  { n: "04", title: "Amazon A+ Content", text: "Modulare Markeninhalte, die Ihre Produktseite in eine überzeugende Markenstory verwandeln." },
  { n: "05", title: "Produkt-Freisteller", text: "Saubere Freisteller auf Weiß oder transparentem Hintergrund – marktplatzkonform in hoher Auflösung." },
  { n: "06", title: "Infografiken", text: "Vorteile und Funktionen auf einen Blick – klar strukturiert, sofort verständlich." },
  { n: "07", title: "Instagram Beiträge", text: "Feed-Grafiken im konsistenten Markenlook, die Aufmerksamkeit und Wiedererkennung erzeugen." },
  { n: "08", title: "Instagram Storys", text: "Vertikale Story-Formate mit klarer Botschaft – bereit für organische Reichweite und Ads." },
];

export const PORTFOLIO = [
  { src: "/images/sauna-pool.webp", label: "KI-Ambientebild", cat: "Wellness · Outdoor", span: "lg:col-span-7 lg:row-span-2", mobile: "aspect-square", pos: "object-center" },
  { src: "/images/skizze.jpg", label: "Technische Produktgrafik", cat: "Maße · Skizze", span: "lg:col-span-5", mobile: "aspect-[5/4]", light: true },
  { src: "/images/dress-patio.jpg", label: "Fashion Lifestyle", cat: "Bekleidung", span: "lg:col-span-5", mobile: "aspect-square", pos: "object-[50%_20%]" },
  { src: "/images/sofa.webp", label: "Lifestyle-Inszenierung", cat: "Möbel · Garten", span: "lg:col-span-4", mobile: "aspect-square", pos: "object-center" },
  { src: "/images/sauna-forest.jpg", label: "Produkt im Kontext", cat: "Outdoor", span: "lg:col-span-4", mobile: "aspect-square", pos: "object-center" },
  { src: "/images/dress-beach.jpg", label: "Kampagnen-Look", cat: "Fashion", span: "lg:col-span-4", mobile: "aspect-square", pos: "object-[50%_15%]" },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Emotionen verkaufen",
    lead: "Menschen kaufen selten nur ein Produkt – sie kaufen die Vorstellung, wie es genutzt wird.",
    text: "Ein hochwertiges Produktfoto kann den Unterschied zwischen einem Klick und einem übersprungenen Angebot ausmachen. Ambiente-Bilder sorgen für:",
    list: ["Professioneller Markenauftritt", "Höhere Aufmerksamkeit", "Mehr Vertrauen", "Bessere Wiedererkennung", "Stärkere Kaufmotivation"],
    img: "/images/sauna-night.jpg",
    caption: "Beispiel: KI-Ambientebild",
  },
  {
    n: "02",
    title: "Informationen schaffen Vertrauen",
    lead: "Technische Grafiken helfen Interessenten dabei, ein Produkt schneller zu verstehen.",
    text: "Geeignet für Maße, Lieferumfang, Materialien, Funktionen, Besonderheiten und Montage. Die Vorteile:",
    list: ["Weniger Rückfragen", "Bessere Verständlichkeit", "Professioneller Gesamteindruck", "Mehr Vertrauen in das Produkt"],
    img: "/images/skizze.jpg",
    caption: "Beispiel: technische Produktgrafik",
    light: true,
  },
  {
    n: "03",
    title: "Individuell statt Vorlage",
    lead: "Mit modernen KI-Technologien entstehen hochwertige Bilder, die Produkte ansprechend präsentieren.",
    text: "Alle Designs werden individuell auf Marke und Zielgruppe abgestimmt – keine Standardvorlagen, sondern Lösungen für Ihren Einsatzzweck.",
    list: ["Realistische Ambiente-Bilder", "Hochwertige Produktinszenierungen", "Infografiken & technische Zeichnungen", "Amazon A+ & Social-Media-Grafiken"],
    img: "/images/dress-studio.jpg",
    caption: "Beispiel: Fashion-Inszenierung",
    aspect: "aspect-[3/4] sm:aspect-[4/5]",
    pos: "object-[50%_25%]",
  },
];

export const BENEFITS = [
  "Individuelle Gestaltung",
  "Schnelle Bearbeitung",
  "Persönlicher Ansprechpartner",
  "Moderne KI-Technologien",
  "Professionelle Nachbearbeitung",
  "Optimiert für E-Commerce",
  "Faire Preise",
  "Individuelle Lösungen statt Standardvorlagen",
];

export const PACKAGES = [
  { id: "starter", name: "Starter", images: "50", price: "500 €", per: "10 € / Bild" },
  { id: "business", name: "Business", images: "100", price: "900 €", per: "9 € / Bild" },
  { id: "pro", name: "Pro", images: "150", price: "1.275 €", per: "8,50 € / Bild", badge: "Bestseller" },
  { id: "premium", name: "Premium", images: "200", price: "1.500 €", per: "7,50 € / Bild" },
];

export const SINGLE = { id: "einzelbild", name: "Einzelnes KI-Bild", price: "30 €", per: "pro Bild" };

export const UNLIMITED = {
  id: "unlimited",
  name: "Unlimited",
  price: "2.000 €",
  per: "pro Monat",
  features: ["Unbegrenzte Anzahl an KI-Bildern", "Professionelle Erstellung nach Kundenwunsch", "Flexible Nutzung für Projekte & Marketing"],
};

export const PACKAGE_OPTIONS = [
  { id: "beratung", label: "Kostenloses Erstgespräch" },
  { id: "einzelbild", label: "Einzelnes KI-Bild – 30 €" },
  { id: "starter", label: "Starter – 50 Bilder – 500 €" },
  { id: "business", label: "Business – 100 Bilder – 900 €" },
  { id: "pro", label: "Pro – 150 Bilder – 1.275 €" },
  { id: "premium", label: "Premium – 200 Bilder – 1.500 €" },
  { id: "unlimited", label: "Unlimited – 2.000 € / Monat" },
];
